import React from 'react'
import { injectIntl } from 'react-intl';
import { supportedLanguages } from '../../../i18n'
import SEO from '../seo'

const HeadIndexBlog = ({ intl, page }) => {
  return (
    <SEO 
      title={page === 1 ? intl.messages.blog.seo.title : `${intl.messages.blog.page} ${page} - ${intl.messages.blog.seo.title}`} 
      description={intl.messages.blog.seo.metadescription}
      meta={[
        { name: 'keywords', content: intl.messages.blog.seo.keywords },
      ]}
      path={`https://wepayout.co/blog`}>
      {Object.keys(supportedLanguages).map((lang, index) => <link key={index} rel="alternate" href={`https://wepayout.co/${lang !== 'en' ? (lang + '/blog') : 'blog'}`} hreflang={lang} />)}
      <link rel="alternate" href="https://wepayout.co/blog" hreflang="x-default" />
    </SEO>
  )
}

export default injectIntl(HeadIndexBlog) 